import { Backdrop } from '@mui/material';
import styled from 'styled-components';

const FilterContainer = styled.div`
  position: sticky;
  width: 100%;
  height: 260px;
  top: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  z-index: ${({ theme }) => theme.zIndex.appBar};
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  width: 100%;
  height: 100%;
  position: absolute;
`;

export { FilterContainer, StyledBackdrop };
